import React, { useMemo } from "react";
import { Pagination } from "antd";
import { useTranslation } from "react-i18next";
import ResponsiveTable from "../design-system/ResponsiveTable";
import { useIsMobile } from "../design-system/useMediaQuery";

const GeneralTable = ({
  pageNo,
  pageSize,
  totalCount,
  data,
  columns,
  setPageNo,
  loading,
  handleContractDetailsClick,
  rowKey
}) => {
  const { t } = useTranslation("dashboard");
  const pathused = location.pathname;
  const isMobile = useIsMobile();

  const translatedColumns = useMemo(() => {
    return columns.map(column => {
      const translatedColumn = { ...column };

      if (column.title && typeof column.title === "string") {
        const translationKey = column.title;

        const translatedTitle = t(`${translationKey}`, { defaultValue: column.title });
        translatedColumn.title = translatedTitle;
      }

      return translatedColumn;
    });
  }, [columns, t]);

  return (
    <ResponsiveTable
      className="contentclass"
      dataSource={data}
      columns={translatedColumns}
      pagination={false}
      showSorterTooltip={false}
      rowKey={rowKey ?? ((record, index) => record._id ?? record.id ?? index)}
      loading={loading}
      scroll={{
        x: "max-content"
      }}
      onRow={record =>
        pathused === "/user/contracts" && handleContractDetailsClick
          ? { onClick: () => handleContractDetailsClick(record) }
          : {}
      }
      // One page of results needs no pager (small client-side lists, e.g. milestone inventory).
      footer={
        (totalCount ?? data?.length ?? 0) <= (pageSize || 10)
          ? undefined
          : () => (
              <div
                className={
                  isMobile ? "d-flex justify-content-center" : "d-flex justify-content-end"
                }
              >
                <Pagination
                  simple={isMobile}
                  showTotal={(total, range) =>
                    t("pagination.showTotal", {
                      rangeStart: range[0],
                      rangeEnd: range[1],
                      total: total,
                      defaultValue: `Showing ${range[0]}-${range[1]} of ${total} items`
                    })
                  }
                  pageSize={pageSize ? pageSize : 10}
                  onChange={val => setPageNo(val)}
                  current={pageNo ? pageNo : 1}
                  total={totalCount ? totalCount : 1}
                  loading={loading ? loading : false}
                />
              </div>
            )
      }
    />
  );
};

export default GeneralTable;
